import { Grid } from '@material-ui/core';
import { StyledLabel, HelperTextContainer, StyledHelperText, StyledTextAreaField } from '../ui';
import { InfoIcon } from 'components/Icons';
import { maxLength } from 'utils/validators';
import { FormTextAreaField } from 'components';

const notesMaxLen = maxLength(50);

export const NotesField = () => {
  return (
    <Grid item xs={12}>
      <Grid style={{ display: 'flex', justifyContent: 'space-between' }}>
        <StyledLabel>Notes</StyledLabel>
        <HelperTextContainer>
          <StyledHelperText>Max. 50 characters</StyledHelperText>
          <InfoIcon />
        </HelperTextContainer>
      </Grid>
      <StyledTextAreaField
        name="notes"
        // @ts-ignore
        component={FormTextAreaField}
        disableUnderline
        fullWidth
        validate={notesMaxLen}
        rows={4}
      />
    </Grid>
  );
};
